import { Image } from 'antd';
import styled, { css } from 'styled-components';

export const TooltipIconWrapper = styled.div<{ $forLabel: boolean }>`
  && {
    .ant-image {
      display: flex;
    }
  }

  ${props =>
    props.$forLabel &&
    css`
      position: absolute;
      top: 0;
      right: -32px;
    `}
`;

export const TooltipIcon = styled(Image)`
  && {
    width: 20px;
    height: 20px;
  }
`;
